/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Define los ordenes para ordenamiento.
 */
export type SortDirection = 'ASC' | 'DESC';

export const SortDirection = {
    ASC: 'ASC' as SortDirection,
    DESC: 'DESC' as SortDirection
};

